export default function Topbar() {
  return (
    <header className="h-14 bg-white border-b shadow-sm flex items-center justify-between px-6">
      <h1 className="text-lg font-bold text-gray-700">پنل مدیریت</h1>

      <div className="text-sm text-gray-500">مربی</div>
    </header>
  );
}
